import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { ImpersonationService } from '@features/impersonation/services/impersonation.service';

export const impersonationInterceptor: HttpInterceptorFn = (request, next) => {
    const ownApiUrl = `${inject(EnvironmentService).hostName()}/api/`;
    const clientId = inject(ImpersonationService).clientId();
    if (!request.url.startsWith(ownApiUrl)) {
        return next(request);
    }
    // Without the header the request runs as the staff member, whose own data
    // would then show in the client's dashboard.
    if (!clientId) {
        throw new Error('Impersonation has not been started');
    }
    return next(
        request.clone({ setHeaders: { 'FA-Impersonate-Client': clientId } })
    );
};
